import { useEffect, useState } from 'react';
import { makeOptionsFromIntegratorList } from './AddAccessTokenFormUtil';
import { changeModalState, changeToasterState, toggleModal } from '../../../Store/layoutSlice';
import { MODAL_STATE, TOASTER_STATE } from '../../../Model/Enums';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useCreateAccessTokenMutation, useLazyGetIntegratorListQuery } from '../../../Store/client';
import { clientListSelector, isRlbSelector, setIsRlb } from '../../../Store/paramsBagSlice';

export const useAddAccessTokenForm = () => {
  const [value, setValue] = useState(null);
  const isRlb = useAppSelector(isRlbSelector);
  const accessTokenList = useAppSelector(clientListSelector);

  const dispatch = useAppDispatch();
  const [getIntegratorList, { data, isLoading: isIntegratorsLoading }] = useLazyGetIntegratorListQuery();
  const [createAccessToken, { isLoading }] = useCreateAccessTokenMutation();

  useEffect(() => {
    getIntegratorList();
    if (isRlb) {
      if (data && accessTokenList) {
        const hasExistingRlbIntegration = accessTokenList?.filter(
          (token) => token.integrator.displayName === 'RLB' && token.status === 'ACTIVE'
        )[0];

        if (hasExistingRlbIntegration) {
          dispatch(changeToasterState(TOASTER_STATE.ACCESS_TOKEN_ALREADY_EXISTS));
          dispatch(setIsRlb(false));
          dispatch(toggleModal());
          return;
        }
        (async () => {
          try {
            await createAccessToken({
              _id: data?.filter((integrator) => integrator.displayName === 'RLB')[0]._id,
            }).unwrap();
            dispatch(changeModalState(MODAL_STATE.REVEAL_SECRET));
          } catch (e) {
            dispatch(toggleModal());
            dispatch(changeToasterState(TOASTER_STATE.ACCESS_TOKEN_CREATION_FAILED));
          }
        })();
      }
    }
    // eslint-disable-next-line
  }, [getIntegratorList, data, accessTokenList]);

  const onClose = () => {
    dispatch(toggleModal());
    dispatch(setIsRlb(false));
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const hasExistingRlbIntegration =
      value?.label === 'RLB' &&
      accessTokenList?.filter((token) => token.integrator.displayName === 'RLB' && token.status === 'ACTIVE')[0];

    if (hasExistingRlbIntegration) {
      dispatch(changeToasterState(TOASTER_STATE.ACCESS_TOKEN_ALREADY_EXISTS));
      dispatch(setIsRlb(false));
      dispatch(toggleModal());
      return;
    }

    const { integrator } = event.target.elements;
    try {
      await createAccessToken({ _id: integrator.value }).unwrap();
      dispatch(changeModalState(MODAL_STATE.REVEAL_SECRET));
    } catch (e) {
      dispatch(toggleModal());
      dispatch(changeToasterState(TOASTER_STATE.ACCESS_TOKEN_CREATION_FAILED));
    }
  };

  return {
    integrators: makeOptionsFromIntegratorList(data),
    onClose,
    inProgress: isLoading,
    isIntegratorsLoading,
    onSubmit,
    setValue,
    disabled: value === null,
  };
};
